import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const BoxWrapper: CSSObject = {
  borderRadius: ['none', 'base'],
  mx: ['-2', '0'],
  pl: '2',
  pr: ['2', '0'],
  mt: '2',
  mb: '0',
  gap: '1',
  h: 'fit-content',

  '&:has(+ .subTabBar)': {
    borderBottomRadius: 'none',
  },

  '&.tabBar': {
    bg: 'blackAlpha.400',
    boxShadow: '0px 3px 3px 0px rgba(0, 0, 0, 0.20) inset',
    borderRadius: ['none', 'lg'],
    h: 'fit-content',
    mt: 2,
    '&:has(+ .subTabBar)': {
      borderBottomRadius: 'none',
    },
  },

  '&.subTabBar': {
    bg: 'beta.500',
    borderBottomRadius: ['none', 'lg'],
    borderTopRadius: 'none',
    boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.10)',
    mt: 0,
    h: 'fit-content',
  },
};

export const buttonTabBarProps: CustomButtonProps = {
  variant: 'quaddiesTab',
  sx: {
    '&&': {
      marginLeft: '0',
      marginRight: '0',
      _hover: {
        borderColor: 'beta.500',
      },
    },
    py: '2',
    '&&[data-active="true"]': {
      bg: 'beta.500',
      borderBottom: 'none',
      h: '34px',
      '& > span': {
        borderRadius: '3px',
        padding: '1',
        bg: 'alpha.600',
        color: 'beta.500',
        fontWeight: 'bold',
        fontSize: 'xs',
      },
    },
    '&&[data-active]': {
      borderRadius: 'none',
    },
    '&.subTab': {
      color: 'alpha.600',
      _hover: {
        borderBottomColor: 'alpha.400',
      },
    },
  },
};

export const buttonTabBarMeetingsProps: CustomButtonProps = {
  variant: 'tab',
};

export const tickForToteMulti: CSSObject = {
  position: 'absolute',
  width: '11px',
  height: '11px',
  bg: 'beta.500',
  top: '-5px',
  right: '-5px',
  borderRadius: '3px',

  _before: {
    content: "' '",
    height: '5px',
    width: '2px',
    backgroundColor: 'alpha.600',
    position: 'absolute',
    top: '3px',
    right: '3px',
    transform: 'rotate(45deg)',
  },

  _after: {
    content: "' '",
    height: '2px',
    width: '4px',
    backgroundColor: 'alpha.600',
    position: 'absolute',
    top: '6px',
    right: '5px',
    transform: 'rotate(210deg)',
  },
};
